import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  CanActivate,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ToasterService } from '../services/toaster/toaster.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _toast: ToasterService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const currentUser = this._authService.currentUserValue;

    // console.log(currentUser);
    if (currentUser) {
      // logged in so return true
      if (
        route.data?.role &&
        currentUser?.roles &&
        currentUser?.roles.indexOf(route.data.role) <= -1
      ) {
        this._toast.showError('Authorized Personnel Only');
        this._router.navigate(['']);
        return false;
      }

      if (state.url === 'login') {
        // this._router.navigate(['']);
      }

      return true;
    }

    this._router.navigate(['login'], { queryParams: { returnUrl: state.url } });
    // not logged in so redirect to login page with the return url
    return false;
  }
}
